<app-megamenu></app-megamenu>

<div class="prevention-tips-page">
  <!-- Hero Section -->
  <div class="hero-section">
    <div class="container">
      <div class="hero-content">
        <h1>Pest Prevention Tips</h1>
        <p class="hero-subtitle">
          Protect your home with proven prevention strategies. Learn how to keep pests out 
          before they become a problem with these expert tips from Complete Pest Control.
        </p>
        <div class="hero-stats">
          <div class="stat-item">
            <mat-icon class="stat-icon">shield</mat-icon>
            <span class="stat-text">Prevention First</span>
          </div>
          <div class="stat-item">
            <mat-icon class="stat-icon">eco</mat-icon>
            <span class="stat-text">Natural Methods</span>
          </div>
          <div class="stat-item">
            <mat-icon class="stat-icon">home</mat-icon>
            <span class="stat-text">Home Protection</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Quick Tips Section -->
  <div class="quick-tips-section">
    <div class="container">
      <h2>Quick Prevention Tips</h2>
      <div class="quick-tips-grid">
        <div *ngFor="let quickTip of quickTips" class="quick-tip-card">
          <mat-icon class="quick-tip-icon">{{ quickTip.icon }}</mat-icon>
          <p>{{ quickTip.tip }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Prevention Categories -->
  <div class="categories-section">
    <div class="container">
      <div class="section-header">
        <h2>Comprehensive Prevention Guide</h2>
        <p>Explore detailed prevention strategies organized by area and season to keep your home pest-free.</p>
      </div>

      <mat-tab-group class="prevention-tabs" animationDuration="300ms">
        <mat-tab *ngFor="let category of preventionCategories">
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">{{ category.icon }}</mat-icon>
            {{ category.title }}
          </ng-template>
          <div class="tab-content">
            <div class="category-header">
              <div class="category-info">
                <h3>{{ category.title }}</h3>
                <p>{{ category.description }}</p>
              </div>
            </div>

            <div class="tips-grid">
              <div *ngFor="let tip of category.tips" class="tip-card">
                <mat-card class="prevention-card">
                  <mat-card-header class="tip-header">
                    <mat-card-title class="tip-title">{{ tip.title }}</mat-card-title>
                    <mat-card-subtitle class="tip-description">{{ tip.description }}</mat-card-subtitle>
                  </mat-card-header>

                  <mat-card-content class="tip-content">
                    <div class="tip-meta">
                      <div class="meta-item">
                        <span class="meta-label">Difficulty:</span>
                        <span class="difficulty-badge" [style.background-color]="getDifficultyColor(tip.difficulty)">
                          {{ tip.difficulty }}
                        </span>
                      </div>
                      <div class="meta-item" *ngIf="tip.season">
                        <span class="meta-label">Season:</span>
                        <span class="meta-value">{{ tip.season }}</span>
                      </div>
                      <div class="meta-item" *ngIf="tip.frequency">
                        <span class="meta-label">Frequency:</span>
                        <span class="meta-value">{{ tip.frequency }}</span>
                      </div>
                    </div>

                    <div class="steps-section">
                      <h4>Steps to Follow:</h4>
                      <ol class="steps-list">
                        <li *ngFor="let step of tip.steps" class="step-item">
                          {{ step }}
                        </li>
                      </ol>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>

  <!-- Professional Help Section -->
  <div class="professional-help-section">
    <div class="container">
      <div class="help-content">
        <div class="help-text">
          <h2>When Prevention Isn't Enough</h2>
          <p>
            While these prevention tips are highly effective, sometimes professional intervention is necessary. 
            If you're dealing with an active infestation or want comprehensive protection, our expert team 
            can provide customized solutions for your specific needs.
          </p>
          <div class="help-features">
            <div class="feature-item">
              <mat-icon>verified</mat-icon>
              <span>Professional Assessment</span>
            </div>
            <div class="feature-item">
              <mat-icon>build</mat-icon>
              <span>Customized Solutions</span>
            </div>
            <div class="feature-item">
              <mat-icon>schedule</mat-icon>
              <span>Ongoing Protection</span>
            </div>
            <div class="feature-item">
              <mat-icon>support</mat-icon>
              <span>Expert Support</span>
            </div>
          </div>
        </div>
        <div class="help-actions">
          <button mat-raised-button class="primary-help-btn" (click)="navigateToContact()">
            <mat-icon>request_quote</mat-icon>
            Get Professional Help
          </button>
          <button mat-button class="secondary-help-btn" (click)="callPhone()">
            <mat-icon>phone</mat-icon>
            Call {{ config.phone.display }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Additional Resources -->
  <div class="resources-section">
    <div class="container">
      <h2>Additional Resources</h2>
      <div class="resources-grid">
        <mat-card class="resource-card" (click)="navigateToPestLibrary()">
          <mat-card-header>
            <mat-icon mat-card-avatar>library_books</mat-icon>
            <mat-card-title>Pest Library</mat-card-title>
            <mat-card-subtitle>Learn about specific pests</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <p>Detailed information about common Utah pests, their habits, and targeted prevention strategies.</p>
          </mat-card-content>
          <mat-card-actions>
            <button mat-button>
              <mat-icon>arrow_forward</mat-icon>
              Explore Library
            </button>
          </mat-card-actions>
        </mat-card>

        <mat-card class="resource-card" (click)="navigateToFAQ()">
          <mat-card-header>
            <mat-icon mat-card-avatar>help</mat-icon>
            <mat-card-title>FAQs</mat-card-title>
            <mat-card-subtitle>Common questions answered</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <p>Find answers to frequently asked questions about pest control and prevention methods.</p>
          </mat-card-content>
          <mat-card-actions>
            <button mat-button>
              <mat-icon>arrow_forward</mat-icon>
              View FAQs
            </button>
          </mat-card-actions>
        </mat-card>

        <mat-card class="resource-card" (click)="navigateToContact()">
          <mat-card-header>
            <mat-icon mat-card-avatar>support_agent</mat-icon>
            <mat-card-title>Expert Consultation</mat-card-title>
            <mat-card-subtitle>Get personalized advice</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <p>Schedule a consultation with our pest control experts for customized prevention strategies.</p>
          </mat-card-content>
          <mat-card-actions>
            <button mat-button>
              <mat-icon>arrow_forward</mat-icon>
              Contact Us
            </button>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>